<template>
  <EditContactsPage
    :get-gql-query="getGqlQuery"
    :get-total-count="getTotalCount"
    :get-contacts="getContacts"
    :get-query-variables="getQueryVariables"
    :update-query-variable="updateQueryVariable"
  />
</template>

<script>
import EditContactsPage from '@/pages/Contact/EditContactsPage'
import { LIST_EDIT_POLLING_CHOIECE_CONTACTS } from '@/backend/graphql/pollingGQL'
export default {
  name: 'EditPollingChoiceContactsPage',
  components: {
    EditContactsPage
  },
  data: function () {
    return {
      getGqlQuery: LIST_EDIT_POLLING_CHOIECE_CONTACTS,
      limit: 50,
      offset: 0,
      orderBy: '-profile__last_recv_at,name',
      pollingEventChoiceId: 0
    }
  },
  created () {
    this.pollingEventChoiceId = this.$route.params.pollingEventChoiceId
  },
  methods: {
    getTotalCount (data) {
      return data.listChoiceProfile.totalCount
    },
    getContacts (data) {
      return data.listChoiceProfile.results.map(obj => obj.profile)
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        pollingEventChoiceId: this.pollingEventChoiceId
      }
    },
    updateQueryVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    }
  }
}
</script>

<style scoped>

</style>
